/**
 * Scroll-to-top button - Vastradevi Theme
 * Shows once the page has scrolled past a threshold; click smooth-scrolls
 * back to the top.
 */
(function () {
  'use strict';

  var btn = document.getElementById('ScrollToTopBtn');
  if (!btn) return;

  var THRESHOLD = 400;

  function toggle() {
    btn.classList.toggle('is-visible', window.scrollY > THRESHOLD);
  }

  window.addEventListener('scroll', toggle, { passive: true });
  toggle();

  btn.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
})();
